import React from 'react';
import styled from 'styled-components';
import Loading from './Loading';

const StyledDiv = styled.div`
  position: fixed;
  background-color: #00000080;
  z-index: 1051;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  .loading-icon {
    width: 250px;
    height: 250px;
  }
`;

const Cover = () => {
  return (
    <StyledDiv>
      <Loading className="loading-icon" />
    </StyledDiv>
  );
};

export default Cover;
